export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h2>What they say</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial">
                    <div className="testimonial-stars">
                      {[...Array(5)].map((_, si) => (
                        <i key={si} className="fa fa-star"></i>
                      ))}
                    </div>
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                    </div>
                    <div className="testimonial-meta" style={{ marginTop: "20px", display: "flex", alignItems: "center", gap: "12px" }}>
                      <a
                        href={d.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ flexShrink: 0 }}
                      >
                        <img
                          src={d.img}
                          alt={d.name}
                          style={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "2px solid rgba(91,141,239,0.25)",
                            display: "block",
                          }}
                        />
                      </a>
                      <span style={{ fontWeight: 700, fontSize: "14px", color: "#1a202c" }}>
                        {d.name}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
